import { storage } from '@doxyme/ui/utils';
import { StorageKeys } from '../../shared/constants';
import { useAuth } from '../useAuth';

export const useGetAccessToken = (): string => {
  const { user } = useAuth();
  // Once all users are using Frontegg `tokenFromStorage` should be removed.
  const tokenFromStorage = `${storage.findItem(StorageKeys.AccessTokenId)}`;

  return user?.accessToken ?? tokenFromStorage;
};
